import styled from 'styled-components';

export const LabelText = styled.span`
  display: block;
  margin-bottom: 0.5rem;
  color: ${({ theme }) => theme.tokens.colors.text[200]};
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1rem;
`;
